import { render, staticRenderFns } from "./LbTableDefaultColumn.vue?vue&type=template&id=18db9ed8"
import script from "./LbTableDefaultColumn.vue?vue&type=script&lang=js"
export * from "./LbTableDefaultColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports